/**
 *  Postal code service
 *
 * Specify the location of the popup (align to the center of the screen)
 */

// width of popup
export const width = 500;
// height of popup
export const height = 600;

const { width: screenWidth, height: screenHeight } = window.screen;

export const left = screenWidth / 2 - width / 2;
export const top = screenHeight / 2 - height / 2;
